import { ReactNode, useEffect } from "react";
import { useOutletContext } from "react-router";

import { IntegrationsOutletContext } from "../types";

export function useLayoutHeading(title: string): void;
export function useLayoutHeading(heading: ReactNode, title: string): void;
export function useLayoutHeading(heading: ReactNode | string, title: string = "") {
  const { setLayoutHeading, setLayoutTitle } = useOutletContext<IntegrationsOutletContext>();

  useEffect(() => {
    if (!heading) {
      setLayoutHeading(null);
      setLayoutTitle("");
    } else {
      if (typeof heading === "string") {
        setLayoutTitle(heading);
      } else {
        setLayoutTitle(title);
      }
      setLayoutHeading(heading);
    }

    return () => {
      setLayoutHeading(null);
      setLayoutTitle("");
    };
  }, [heading, setLayoutHeading, setLayoutTitle, title]);
}
